import { FLOW_TYPE_TO_NUMBER } from 'consts';
import { HERO_URL_AV } from 'consts/api';
import { ENTITY_TYPE, FLOW_TYPE, RENEW_PREFIX } from 'consts/flows';
import { AppContext } from 'providers/AppContext';
import { useContext, useEffect } from 'react';
import { LINKS, LINKS_AV } from './finish.consts';
import { FinishPageTranslationKeys } from './finish.helpers';

export type FinishPageProps = Readonly<ReturnType<typeof useFinish>>;

export function useFinish() {
	const ctx = useContext(AppContext);
	const { config, entityType, fetchRelations, flowType, http, state, t } = ctx;
	const { agreementProcessId = '', portfolioId = '' } = state.context.processInfo || {};
	const individual = entityType === ENTITY_TYPE.INDIVIDUAL;
	const baseFlowType = flowType.replace(RENEW_PREFIX, '').toUpperCase();
	const riskRenewalFlowType = (FLOW_TYPE_TO_NUMBER as Record<string, number>)[baseFlowType];
	const links = LINKS[entityType];
	const isAV = FLOW_TYPE.AV === flowType;
	const showTitle = isAV ? false : individual && (flowType === FLOW_TYPE.MV || flowType === FLOW_TYPE.RR_MV);
	const keys = FinishPageTranslationKeys(entityType, flowType, portfolioId);

	const buttonAction = () => {
		globalThis.location.href = isAV ? HERO_URL_AV : LINKS_AV.login_to_online_banking(config.APP_ENV);
	};

	useEffect(() => {
		if (FLOW_TYPE.RR_EB === flowType || FLOW_TYPE.RR_ER === flowType || FLOW_TYPE.RR_MV === flowType) {
			http
				.post(
					config.API.completeRiskQRenewalProcess,
					{ agreementProcessId, riskRenewalFlowType },
					t('loading_label', 'finish')
				)
				.then(fetchRelations);
		}
	}, [agreementProcessId, riskRenewalFlowType, flowType]); // eslint-disable-line react-hooks/exhaustive-deps

	return {
		...ctx,
		buttonAction,
		keys,
		links,
		showTitle
	};
}
